import axios from "axios";

const state = {
  products: [],
  // productsTotal: this.products.size,
  currentPage: 1
  // pageSize: this.products.length / 12
};

const getters = {
  allProducts: state => state.products
};

const actions = {
  async fetchProducts({ commit }) {
    const response = await axios.get(`${process.env.VUE_APP_API}/products`);

    commit("setProducts", response.data.data);
  }
};

const mutations = {
  setProducts: (state, products) => (state.products = products)
};

export default {
  state,
  getters,
  actions,
  mutations
};
